// extracted by mini-css-extract-plugin
export var closeButton = "b4_hF";
export var dialogWrapper = "b4_hG";
export var mainContent = "b4_hD";
export var modalWrapper = "b4_hC";